
import organization from './config-organization';
import position from './config-position';
import WizTableForm from "../wizTableForm";

const organizationConfig = organization(this, { apiParams: { state: 1, organizationNodeCategory:["2"] } });
const positionConfig = position(this, { apiParams: { state: 1 } });

const columns = () => {
  return [
    {
      title: '名称',
      name: 'name',
      dataIndex: 'name',
      tableItem: {
        width: 220
      },
      searchItem: {}
    },
    {
      title: '品牌',
      name: 'orgId',
      dataIndex: 'orgId',
      searchItem: {
        ...organizationConfig,
        diy: WizTableForm,
        selectType: 'radio',
      }
    },
    {
      title: '品牌',
      name: 'orgName',
      dataIndex: 'orgName',
      tableItem: {
        width: 220
      }
    },
    {
      title: '岗位',
      name: 'positionsName',
      dataIndex: 'positionsName',
      tableItem: {
        width: 220
      }
    },
    {
      title: '岗位',
      name: 'positionIds',
      dataIndex: 'positionIds',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm
      }
    },
    {
      title: '状态',
      name: 'state',
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' },
      ],
      dataIndex: 'state'
    }
  ]
};

const tableApi = (api = {}) => {
  return {
    path: 'abilityCheckCategory/listByPage',
    ...api
  }
};

const abilityCheckCategory = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    tableApi: tableApi(api)
  }
};

export default abilityCheckCategory
